import _ from "lodash"
import moment from "moment"
import storePersist from "../../redux/storePersist"
import * as R from "ramda"
import { DecodedToken, decodeToken } from "./decode-jwt"


export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj))

export const format = (date: any) => {
  if (date) {
      const localDateFormatted = moment(date).local()
          .format('YYYY-MM-DD hh:mm:ss a')
      return localDateFormatted
  }
  return ''
}
export const currency = (money: any) => {

    var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
    const countryCode  =
      metaTokenMetaData.CountryCode;
      const currencyCode = 
      metaTokenMetaData.CurrencyCode;
      const languageCode = 
      metaTokenMetaData.LanguageCode;

  const moneyArr: any = _.split(
      money,
      '.'
  )

  let finalMoneyString = Intl.NumberFormat(
      `${languageCode}-${countryCode}`,
      {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          maximumSignificantDigits: 3
      }
  ).format(moneyArr[0])

  if (moneyArr?.length > 1) {
      finalMoneyString += `.${moneyArr[1]}`
  }

  return finalMoneyString
}
export const getCurrencySymbol = (label: any) => {


  let currencySymbol: any = null;
  var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
  const countryCode  =
    metaTokenMetaData?.CountryCode;
    const currencyCode = 
    metaTokenMetaData?.CurrencyCode;
    const languageCode = 
    metaTokenMetaData?.LanguageCode;

  if (label?.length > 0 &&
      R.find((subString) => label.indexOf(subString) > -1)([
          'Price',
          'Cost',
          'Amount',
          'Amt',
          'Charge',
          'Charges',
          'MRP'
      ])
  ) {
      // const options = { style: 'currency', currency: currencyCode };
      // const us = new Intl.NumberFormat(languageCode, options);
      const valueWithCurrency = Number(0).toLocaleString(languageCode, {
          style: "currency",
          currency: currencyCode,
          minimumFractionDigits: 2
      });
      const valueWithoutCurrency = valueWithCurrency.replace(Number(0).toLocaleString(languageCode, {
          minimumFractionDigits: 2
      }), "")

      currencySymbol = valueWithoutCurrency
  }
  return currencySymbol
}


export function updateNestedValue(obj, path, value) {
  if (!path) {
    return obj
  }
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      const isArrayIndex = !isNaN(key) && parseInt(key, 10) == key;
      
      if (isArrayIndex) {
          // If it's an array index, ensure the current level is an array
          if (!Array.isArray(current)) {
              current = [];
          }
      } else {
          if (!current[key] || typeof current[key] !== 'object') {
              current[key] = {};
          }
      }
      current = current[key];
  }

  current[keys[keys.length - 1]] = value;
  return obj;
}

export const getAccountTypeChannalName = () => {
  const accessToken = storePersist?.get("accessTokenMetadata")?.current?.JwtToken;

  if (accessToken) {
      const decodedToken: DecodedToken | null = decodeToken(accessToken);
      if (decodedToken) {

          return decodedToken;
      } else {
          // Handle invalid accessToken
          // Redirect to login page, show error message, etc.
          return null;
      }
  } else {
      // Handle case when accessToken is not present
      // Redirect to login page, show error message, etc.
      return null;
  }
}

 export const getSelectedOptionLabel = (list: any, labelField: any, valueField: any, value: any) => {
    const item = _.find(list, (item) => {
      const itemValue = _.property(valueField)(item);
      return itemValue == value;
    })
    if (item) {
      return _.property(labelField)(item)
    } else {
      return ''
    }
  }

  export const getSelectedOptionValue = (list: any, labelField: any, valueField: any, value: any) => {
    const item = _.find(list, (item) => {
      const itemValue = _.property(labelField)(item);
      return itemValue == value;
    })
    if (item) {
      return _.property(valueField)(item);
    } else {
      return ''
    }
  }

export const getHostName = () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'){
      return "edgenet.digiit.io"
    } else {
      return window.location.hostname
    }    
  }
  
  
  export const getOrigin = () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'){
      return "https://fashme.csp.digiit.io"
      // return "https://digiitbiz.csp.digiit.ai"
    } else {
      if (window.location.origin.includes('x.digiit.io')){
        return "https://dbs.csp.digiit.io"
      } else if(window.location.origin.includes('y.digiit.io')){
        return "https://agri.csp.digiit.io"
      } else if(window.location.origin.includes('z.digiit.io')){
        return "https://fashme.csp.digiit.io"
      } else if (window.location.origin.includes('x.digiit.ai')){
        return "https://dbs.csp.digiit.ai"
      } else if(window.location.origin.includes('y.digiit.ai')){
        return "https://agri.csp.digiit.ai"
      } else if(window.location.origin.includes('z.digiit.ai')){
        return "https://quco.csp.digiit.ai"
      } else if(window.location.origin.includes('fusionnet.digiit.io')){
        return "https://fashme.csp.digiit.io"
      } else if (window.location.origin.includes('edgenet.digiit.io')){
        return "https://fashme.csp.digiit.io"
      } else if(window.location.origin.includes('fusionnet.digiit.ai')){
        return "https://digiitbiz.csp.digiit.ai"
      } else if (window.location.origin.includes('edgenet.digiit.ai')){
        return "https://digiitbiz.csp.digiit.ai"
      } else
        return window.location.origin.replace(/\.digiit\./, ".csp.digiit.")
      }      
    }    